import { Link } from "react-router-dom";
import React from "react";
import { useGlobalState } from "./GlobalContext";

export default function ErrorComponent(props) {
    const { error } = props;
    const { labelLogo } = useGlobalState();
    console.error(error);

    const clearCache = () => {
        // Clear cache and reload page
        localStorage.clear();
        window.location.reload();
    };

    return (
        <div className={"error"}>
            <img src={labelLogo?.url} className="logo" alt="logo" />
            <strong>Er heeft zich een fout voorgedaan tijdens het laden van de configurator.</strong>
            <a href={"#"} onClick={clearCache}>
                probeer het opnieuw
            </a>
        </div>
    );
}
